// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalInventoryLogs_root__34aQT","log":"ModalInventoryLogs_log__cBm1L","date":"ModalInventoryLogs_date__2Ve5M","userName":"ModalInventoryLogs_userName__2dYpi"};